<script>
  import { onDestroy } from "svelte";
  import { lang } from "../lib/stores";
  import MapBaggio from "./MapBaggio.svelte";
  import MapMilano from "./MapMilano.svelte";
  import MapWorld from "./MapWorld.svelte";
  let selectedLang;
  const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);

  export let data = {};
</script>

<section class="chapter-3 chapter-inner">
  <div class="p">
    <p>
      {#if selectedLang === 'it'}
        Ghali, italiano di origini tunisine, ha dimostrato più volte di essere
        molto legato al quartiere di
        <em>Milano</em> nel quale è cresciuto: <em>Baggio</em>. Lo ha fatto in
        diverse interviste, ma anche nei suoi testi. Vediamo quali sono i luoghi
        citati da Ghali, e in quali contesti. E visto che anche noi siamo fieri
        baggesi, parliamo un po' di questo quartiere, delle sue enormi
        potenzialità e dei suoi innegabili problemi.
      {:else}
        Ghali, an Italian of Tunisian origins, has repeatedly shown that he is very attached to the neighborhood of
        <em>Milan</em> where he grew up: <em>Baggio</em>. He has done so in several interviews, but also in his
        lyrics. Let's see which places Ghali mentions, and in which contexts. And since we too are proud <em>Baggesi</em>,
        let's talk a little about this neighborhood, its enormous potential and its undeniable problems.
      {/if}
    </p>
  </div>
  <div class="subtitle">
    <h3>
      {#if selectedLang === 'it'}
        Da Milano a Calcutta
      {:else}
        From Milan to Kolkata
      {/if}
    </h3>
    <h2>
      {#if selectedLang === 'it'}
        Tutto il mondo di Ghali
      {:else}
        The Whole World of Ghali
      {/if}
    </h2>
  </div>
  <MapWorld data={data.chapter3} />
  <div class="subtitle">
    <h3>
      {#if selectedLang === 'it'}
        La mia città
      {:else}
        My City
      {/if}
    </h3>
    <h2>{#if selectedLang === 'it'}Perché{:else}Because{/if} Milàn l'è un gran Milàn</h2>
  </div>
  <MapMilano />
  <div class="subtitle">
    <h3>Baggio</h3>
    <h2>
      {#if selectedLang === 'it'}
        Trasformo Baggio in un posto più bello
      {:else}
        Turning Baggio into a better place
      {/if}
    </h2>
  </div>
  <MapBaggio />
</section>

<style>
</style>
